import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DropdownModule} from 'primeng/components/dropdown/dropdown';

import {ArtefatoServicoComponent} from './servico/servico.component';
import {ArtefatoOperacaoComponent} from './operacao/operacao.component';
import {ArtefatoLayoutArquivoComponent} from './layout-arquivo//layout-arquivo.component';
import {ArtefatoInstalacaoProdutoComponent} from './instalacao-produto/instalacao-produto.component';

import {CadastroInstalacaoProdutoComponent} from './cadastro-instalacao-produto/cadastro-instalacao-produto.component';
import {CadastroLayoutArquivoComponent} from './cadastro-layout-arquivo/cadastro-layout-arquivo.component';
import {CadastroOperacaoComponent} from './cadastro-operacao/cadastro-operacao.component';
import {CadastroServicoComponent} from './cadastro-servico/cadastro-servico.component';
import {
    ItemParametroConteudoInstalacaoProdutoComponent
} from './item-param-conteudo-instalacao-produto/item-param-conteudo-instalacao-produto.component';
import {MyDatePickerModule} from 'mydatepicker';

import {AppRoutingModule} from '../app-routing.module';

import {FiltroNome} from './filtro/filtro-nome';
import {ProdutoTransmissaoComponent} from './produto-transmissao/produto-transmissao.component';
import {
    CadastroProdutoTransmissaoComponent
} from './cadastro-produto-transmissao/cadastro-produto-transmissao.component';

// import { HomeArtefatoComponent } from './home-artefato/home-artefato.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        MyDatePickerModule,
        DropdownModule,
    ],
    declarations: [
        ArtefatoServicoComponent,
        ArtefatoLayoutArquivoComponent,
        ArtefatoOperacaoComponent,
        ArtefatoInstalacaoProdutoComponent,
        CadastroInstalacaoProdutoComponent,
        CadastroLayoutArquivoComponent,
        CadastroOperacaoComponent,
        CadastroServicoComponent,
        ItemParametroConteudoInstalacaoProdutoComponent,
        FiltroNome,
        ProdutoTransmissaoComponent,
        CadastroProdutoTransmissaoComponent
        // HomeArtefatoComponent
    ],
    providers: [],
    exports: []
})
export class ArtefatoModule {
}



// WEBPACK FOOTER //
// ./src/app/artefato/artefato.module.ts